import { render, staticRenderFns } from "./GroupMemberCard.vue?vue&type=template&id=5d51ff24&scoped=true"
import script from "./GroupMemberCard.vue?vue&type=script&lang=js"
export * from "./GroupMemberCard.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberCard.vue?vue&type=style&index=0&id=5d51ff24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d51ff24",
  null
  
)

export default component.exports